import { render } from "./IframePreview.vue?vue&type=template&id=6d81e5ef&scoped=true"
import script from "./IframePreview.vue?vue&type=script&lang=js"
export * from "./IframePreview.vue?vue&type=script&lang=js"

import "./IframePreview.vue?vue&type=style&index=0&id=6d81e5ef&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d81e5ef"]])

export default __exports__